import { render, staticRenderFns } from "./IsPinned.vue?vue&type=template&id=dbc845c6"
import script from "./IsPinned.vue?vue&type=script&lang=js"
export * from "./IsPinned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports